// extracted by mini-css-extract-plugin
module.exports = {"btn":"style__btn__E2M5t","btn-secondary":"style__btn-secondary__l+3h0","active":"style__active__caFx3","name":"style__name__2-nCs"};